import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getLovItems } from '../../services/api';
import type { LovValue } from '../../utils/common';

export const fetchLovValues = createAsyncThunk('lov/fetchLovValues', async () => {
  const data = await getLovItems();
  return data;
});

interface LovState {
  values: LovValue[];
  loading: boolean;
  error: string | null;
}

const initialState: LovState = {
  values: [],
  loading: false,
  error: null,
};

const lovSlice = createSlice({
  name: 'lov',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLovValues.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLovValues.fulfilled, (state, action) => {
        state.values = action.payload;
        state.loading = false;
      })
      .addCase(fetchLovValues.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default lovSlice.reducer;